import { render, staticRenderFns } from "./Intelligent-chat.vue?vue&type=template&id=245e034c&scoped=true&"
import script from "./Intelligent-chat.vue?vue&type=script&lang=js&"
export * from "./Intelligent-chat.vue?vue&type=script&lang=js&"
import style0 from "./Intelligent-chat.vue?vue&type=style&index=0&id=245e034c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e034c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245e034c')) {
      api.createRecord('245e034c', component.options)
    } else {
      api.reload('245e034c', component.options)
    }
    module.hot.accept("./Intelligent-chat.vue?vue&type=template&id=245e034c&scoped=true&", function () {
      api.rerender('245e034c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/Intelligent-chat.vue"
export default component.exports